<template>
  <main class="main">
    <div class="group support group--narrow db" v-if="!hasPosition">
      <h2 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1">We are here to help you</h2>
      <p class="p">Are you in a position that is engaged or connected with the movement of the train or subject to Hours of Service laws and/or is subject to regulated drug testing by the Department of Transportation? <span @click="positions = !positions" class="link">View list of positions</span></p>

      <transition-expand-height v-if="positions">
        <div class="grid grid--positions mt mb0">
          <div class="grid__item grid__item--3">
            <ul class="list">
              <li class="li">Locomotive Engineer</li>
              <li class="li">LEO and HEO (Class 4 Engineer)</li>
              <li class="li">Stationary Engineer</li>
              <li class="li">Conductor</li>
              <li class="li">Assistant Conductor</li>

              <li class="li">Flagman</li>
              <li class="li">Train Dispatcher</li>
              <li class="li">Load Dispatcher</li>
              <li class="li">Power Director</li>
              <li class="li">Block Operator</li>
            </ul>
          </div>

          <div class="grid__item grid__item--3">
            <ul class="list">
              <li class="li">Leverman</li>
              <li class="li">Train Director</li>
              <li class="li">Signal Maintainer</li>
              <li class="li">Cab Signal Electrician</li>
              <li class="li">Machine Operator/EWE</li>

              <li class="li">M/W Repairmen</li>
              <li class="li">Road Mechanic</li>
              <li class="li">Watchmen</li>
              <li class="li">Mechanical Repairmen</li>
              <li class="li">Welders</li>
            </ul>
          </div>

          <div class="grid__item grid__item--3">
            <ul class="list">
              <li class="li">Electricians (substation)</li>
              <li class="li">Lineman</li>
              <li class="li">Yardmaster</li>
              <li class="li">Foremen</li>
              <li class="li">Supervisors</li>
            </ul>
          </div>
        </div>
      </transition-expand-height>

      <div class="mt0">
        <module-button
          button="primary"
          @click.native="nextQuestion"
          label="No"
        />

        <module-button
          button="primary"
          @click.native="hasPosition = true"
          label="Yes"
        />
      </div>
    </div>

    <div class="group group--narrow support db" v-if="hasPosition">
      <h2 class="h2 mt0">Help is Available</h2>
      <p class="p mb0">
        You hold a safety-sensitive position, as defined by Amtrak policy. Please contact your EAP at {{ org.safety_screen_phone }}. Our care team has certified counselors available 24/7 that are ready to listen and direct you to the right help.
      </p>
      <div class="mt0">
        <module-button
          button="primary"
          @click.native="goToHomepage"
          label="Back to Homepage"
        />
      </div>
    </div>
  </main>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { getLastQuestionId } from 'utils/questionnaire';
import TransitionExpandHeight from 'components/ExpandHeight';

// Export
export default {
  name: 'view-safety-screen',

  components: {
    TransitionExpandHeight,
  },

  // Data
  data() {
    return {
      positions: false,
      hasPosition: false,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
  },

  methods: {
    ...mapActions('questions', [
      'requestSingleQuestion',
    ]),
    ...mapActions('app', ['setErrorMessage', 'setErrorRedirect']),

    riskPage() {
      return window.location.href = this.org.safety_screen_url;
    },

    goToHomepage() {
      this.$store.dispatch('auth/resetAllData');
      this.$router.push({ name: 'home' });
    },

    nextQuestion() {

      localStorage.setItem('isSafe', true);

      const safeQuestion =  localStorage.getItem('safeNextQuestion');

      if (safeQuestion) {
        localStorage.removeItem('safeNextQuestion');
        this.$router.push({ name: 'support-detail', params: { id: safeQuestion } });
      } else {
        const complaint = JSON.parse(localStorage.getItem('objectComplaint'));
        const answerComplaint = localStorage.getItem('answerComplaint');

        const choices = complaint.choices;

        choices.forEach((item) => {
          if (answerComplaint === item.text) {
            if (item.next_question) {
              const questionId = getLastQuestionId('f2f') || getLastQuestionId('intakeDetail');

              this.requestSingleQuestion(item.next_question)
                .then(res => {
                  const routeName = getLastQuestionId('f2f') ? 'face-2-face' : 'support-detail';
                  this.$router.push({ name: routeName, params: { id: questionId || res.data.id } });
                })
                .catch(err => (err));
            } else {
              this.$router.push('results');
            }
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// SafetyScreen.vue?37c35ae1